import { render, staticRenderFns } from "./ColorDelete.vue?vue&type=template&id=21f0c6b0&"
import script from "./ColorDelete.vue?vue&type=script&lang=js&"
export * from "./ColorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports